import styled from 'styled-components'

export const QuestionContainer = styled.div`
  height: 120px;
  max-width: 320px;
  margin-left: 8px;
  margin-right: 8px;
  width: 100%;
`
